[
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                "info": {
                    "id": "151990",
                    "name": "Sip & Bite",
                    "city": "Sri Ganganagar",
                    "slugs": {
                        "restaurant": "days-and-night-bakers-sri-ganganagar-saraswati-nagar",
                        "city": "sri-ganganagar"
                    },
                    "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                    "cloudinaryImageId": "zcotw9pv1l8mbjxmqs9l",
                    "locality": "Block G",
                    "areaName": "Saraswati Nagar",
                    "costForTwo": "10000",
                    "costForTwoMessage": "₹100 for two",
                    "cuisines": [
                        "Pastas",
                        "Desserts"
                    ],
                    "avgRating": 3.7,
                    "veg": true,
                    "feeDetails": {
                        "restaurantId": "151990",
                        "fees": [
                            {
                                "name": "time"
                            },
                            {
                                "name": "distance",
                                "fee": 2000
                            },
                            {
                                "name": "special"
                            }
                        ],
                        "totalFee": 2000,
                        "icon": "v1648208530/surgecreatives/info",
                        "message": "Very Far (1,923.6 kms) | Additional delivery fee will apply"
                    },
                    "parentId": "188690",
                    "avgRatingString": "3.7",
                    "totalRatingsString": "1K+ ratings",
                    "sla": {
                        "restaurantId": "151990",
                        "lastMileTravel": 1923.7,
                        "serviceability": "NON_SERVICEABLE",
                        "rainMode": "RAIN_MODE_NONE",
                        "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                        "lastMileTravelString": "1923.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                        "nextCloseTime": "2023-11-28 23:59:00",
                        "visibility": true,
                        "opened": true,
                        "restaurantClosedMeta": {}
                    },
                    "aggregatedDiscountInfo": {
                        "header": "50% off",
                        "shortDescriptionList": [
                            {
                                "meta": "50% off | Use TRYNEW",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            },
                            {
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            }
                        ],
                        "descriptionList": [
                            {
                                "meta": "50% off up to ₹100 | Use code TRYNEW",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            },
                            {
                                "meta": "20% off upto ₹125 | Use BOBFEST Above ₹299",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            }
                        ],
                        "visible": true
                    },
                    "badges": {},
                    "slugString": "days-and-night-bakers-sri-ganganagar-saraswati-nagar",
                    "isOpen": true,
                    "labels": [
                        {
                            "title": "Timings",
                            "message": "null"
                        },
                        {
                            "title": "Address",
                            "message": "180 G Block, Sri Ganganagar"
                        },
                        {
                            "title": "Cuisines",
                            "message": "Pastas,Desserts"
                        }
                    ],
                    "totalRatings": 1000,
                    "aggregatedDiscountInfoV2": {
                        "header": "50% off",
                        "shortDescriptionList": [
                            {
                                "meta": "50% off | Use TRYNEW",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            },
                            {
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            }
                        ],
                        "descriptionList": [
                            {
                                "meta": "50% off up to ₹100 | Use code TRYNEW",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            },
                            {
                                "meta": "20% off upto ₹125 | Use BOBFEST Above ₹299",
                                "discountType": "Percentage",
                                "operationType": "RESTAURANT"
                            }
                        ],
                        "couponDetailsCta": "View coupon details"
                    },
                    "type": "F",
                    "headerBanner": {
                        "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/151990"
                    },
                    "ratingSlab": "RATING_SLAB_4",
                    "availabilityServiceabilityMessage": "Does not deliver to your location",
                    "orderabilityCommunication": {
                        "title": {
                            "text": "Wish you were"
                        },
                        "subTitle": {
                            "text": "CLOSER!"
                        },
                        "message": {
                            "text": "This location is outside the outlet's delivery area",
                            "textColour": "negative"
                        },
                        "customIcon": {
                            "bgGradientColorStart": "#F64C41",
                            "bgGradientColorEnd": "#E53554"
                        }
                    },
                    "hasBestsellerItems": true,
                    "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                    },
                    "latLong": "29.92039066794756,73.87180288158419"
                },
                "analytics": {}
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                "layout": {
                    "rows": 1,
                    "columns": 3,
                    "horizontalScrollEnabled": true,
                    "itemSpacing": 12,
                    "lineSpacing": 10,
                    "widgetPadding": {},
                    "containerStyle": {
                        "containerPadding": {
                            "left": 10,
                            "right": 10
                        }
                    },
                    "scrollBar": {
                        "scrollThumbColor": "#E46D47",
                        "scrollTrackColor": "#e4e4e4",
                        "width": 54,
                        "height": 4,
                        "scrollStyling": {
                            "padding": {
                                "top": 20,
                                "bottom": 20
                            }
                        }
                    }
                },
                "id": "offerCollectionWidget",
                "gridElements": {
                    "infoWithStyle": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                        "offers": [
                            {
                                "info": {
                                    "header": "50% OFF UPTO ₹100",
                                    "offerTagColor": "#E46D47",
                                    "offerIds": [
                                        "95d0ee29-6923-4a2c-97fe-afaadbaee172"
                                    ],
                                    "expiryTime": "1970-01-01T00:00:00Z",
                                    "couponCode": "USE TRYNEW",
                                    "description": "ABOVE ₹129",
                                    "offerType": "offers",
                                    "restId": "151990",
                                    "offerLogo": "offers/generic",
                                    "descriptionTextColor": "#7302060C"
                                },
                                "cta": {
                                    "type": "OFFER_HALF_CARD"
                                }
                            },
                            {
                                "info": {
                                    "header": "20% OFF UPTO ₹125",
                                    "offerTagColor": "#E46D47",
                                    "logoBottom": "rng/md/ads/production/41883e85327a5a799d45d9b95f3510a3",
                                    "offerIds": [
                                        "49e2c1e9-c4a0-494e-b8e7-d18a6d138138"
                                    ],
                                    "expiryTime": "1970-01-01T00:00:00Z",
                                    "couponCode": "USE BOBFEST",
                                    "description": "ABOVE ₹299",
                                    "offerType": "offers",
                                    "restId": "151990",
                                    "offerLogo": "rng/md/ads/production/41883e85327a5a799d45d9b95f3510a3",
                                    "descriptionTextColor": "#7302060C"
                                },
                                "cta": {
                                    "type": "OFFER_HALF_CARD"
                                }
                            },
                            {
                                "info": {
                                    "header": "FLAT ₹200 OFF",
                                    "offerTagColor": "#E46D47",
                                    "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                                    "offerIds": [
                                        "30457c66-5829-4767-82c5-89b791ba7155"
                                    ],
                                    "expiryTime": "1970-01-01T00:00:00Z",
                                    "couponCode": "USE AXIS200",
                                    "description": "ABOVE ₹500",
                                    "offerType": "offers",
                                    "restId": "151990",
                                    "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                                    "descriptionTextColor": "#7302060C"
                                },
                                "cta": {
                                    "type": "OFFER_HALF_CARD"
                                }
                            }
                        ],
                        "habitMilestoneInfo": {
                            "callout": {}
                        }
                    }
                }
            }
        }
    },
    {
        "card": {
            "card": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
                "tabs": [
                    {
                        "id": "REGULAR",
                        "title": "Full Menu",
                        "selected": true,
                        "analytics": {},
                        "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                        "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                    }
                ]
            }
        }
    },
    {
        "groupedCard": {
            "cardGroupMap": {
                "REGULAR": {
                    "cards": [
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                    "isPureVeg": true,
                                    "badges": {},
                                    "vegOnlyDetails": {
                                        "imageId": "AutoVegOnly_qkjowj",
                                        "title": "Showing only vegetarian options.",
                                        "description": "Tap on the VEG ONLY button to turn off the setting"
                                    },
                                    "topRatedFilter": {},
                                    "kidsCategoryFilter": {
                                        "attributes": {
                                            "displayText": "Kids Favourites",
                                            "tooltip": {
                                                "enabled": true,
                                                "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                            }
                                        }
                                    },
                                    "vegFilter": {
                                        "attributes": {
                                            "displayText": "VEG"
                                        }
                                    },
                                    "nonvegFilter": {
                                        "attributes": {
                                            "displayText": "NONVEG"
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Recommended",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814978",
                                                    "name": "Spicy Tandoori Sandwich",
                                                    "category": "Burgers And Sandwiches",
                                                    "imageId": "125cbc99ee12ae38cffd920457c7475e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095499",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095498",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.7",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814981",
                                                    "name": "Cheese Corn Sandwich",
                                                    "category": "Burgers And Sandwiches",
                                                    "imageId": "c99019c2fe99fa7aa6e63a86abbd4076",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095490",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095489",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.1",
                                                            "ratingCount": "18 ratings",
                                                            "ratingCountV2": "18"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106358",
                                                    "name": "Falafel Sub",
                                                    "category": "Sub",
                                                    "imageId": "u1ufmirwo13udeame9re",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094947",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094946",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.8",
                                                            "ratingCount": "8 ratings",
                                                            "ratingCountV2": "8"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106359",
                                                    "name": "Hara Bhara Kabab Sub",
                                                    "category": "Sub",
                                                    "imageId": "vfevo8dvkp3jelpxmnlx",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094950",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094949",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.0",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901444",
                                                    "name": "Cheesy Paneer Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushroom, Golden Corn, Broccoli, Mixed Capsicum With Cheesy Creamy Red Sauce.",
                                                    "imageId": "lwizmtizfrgz4nonjskf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095043",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095041",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095042",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901449",
                                                    "name": "Makhani Gravy Pasta",
                                                    "category": "Pasta",
                                                    "description": "Golden Corn, Green Zucchini, Mushroom, Mix Capsicum, Broccoli Red Sauce.",
                                                    "imageId": "hht1kgq5vjnwvrosmkcu",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095055",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095052",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095054",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901452",
                                                    "name": "Red Sause Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushroom, Zucchini, Broccoli, Mixed Capsicum With Italian Napoli Red Sauce.",
                                                    "imageId": "6b4fd15230669d12ed5243bd695abf6e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095063",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095060",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095062",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.5",
                                                            "ratingCount": "14 ratings",
                                                            "ratingCountV2": "14"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777492",
                                                    "name": "Creamy Alferado Pasta",
                                                    "category": "Pasta",
                                                    "description": "Broccoli, Mushrooms, Capsicum, Golden Corns With Chef'S Special White Sauce.",
                                                    "imageId": "bebhwh4vdput2n5xhhox",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095047",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095045",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095046",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "1.5",
                                                            "ratingCount": "16 ratings",
                                                            "ratingCountV2": "16"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814315",
                                                    "name": "Chilly Paneer Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onions, Green Capsicum, Mushrooms Marinated Paneer And Sliced Black Olives.",
                                                    "imageId": "y4qvzirgfp5jr0dbs0eo",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987176",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571762",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571763",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571764",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571762"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095132",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095135",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571763"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095140",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095138",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571764"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095141",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095143",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095133",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095142",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095139",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095137",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095132",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095138",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095141",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095135",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095140",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095143",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095136",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.8",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814419",
                                                    "name": "Veg Fiesta Pizza",
                                                    "category": "Pizza",
                                                    "description": "Sweet Corn, Onion, Capsicum And Broccoli.",
                                                    "imageId": "79ca19af04ebdeaa48f1a48715e21b37",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987197",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 210,
                                                                        "default": 1,
                                                                        "id": "77571826",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 310,
                                                                        "id": "77571827",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 410,
                                                                        "id": "77571828",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571826"
                                                                    }
                                                                ],
                                                                "price": 21000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095382",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095384",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571827"
                                                                    }
                                                                ],
                                                                "price": 31000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095389",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095388",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571828"
                                                                    }
                                                                ],
                                                                "price": 41000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095391",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095392",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095381",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095390",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095387",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095386",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095382",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095388",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095391",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095384",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095389",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095392",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095385",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 21000,
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.2",
                                                            "ratingCount": "27 ratings",
                                                            "ratingCountV2": "27"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814460",
                                                    "name": "Cheese Corn Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Corn And Basil With Spices.",
                                                    "imageId": "627d39f2d09159ecd8a6c660207032bf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987172",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571750",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571751",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571752",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571750"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095085",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095087",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571751"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095092",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095091",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571752"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095094",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095095",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095084",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095093",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095090",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095089",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095085",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095091",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095094",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095087",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095092",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095095",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095088",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.2",
                                                            "ratingCount": "134 ratings",
                                                            "ratingCountV2": "134"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106399",
                                                    "name": "Masala Paneer Makhani Pizza",
                                                    "category": "Pizza",
                                                    "description": "Marinated Paneer, Onion, Capsicum Red Paprika,Tomatoes, Coriander Cheese With Hot Cheese Topping.",
                                                    "imageId": "1f9dd9907f24daf44583e7b34673bef1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987183",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571784",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571785",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571786",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571784"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095217",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095219",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571785"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095224",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095223",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571786"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095226",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095227",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095216",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095225",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095222",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095221",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095217",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095223",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095226",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095219",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095224",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095227",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095220",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.6",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106404",
                                                    "name": "Ultimate Paneer Pizza",
                                                    "category": "Pizza",
                                                    "description": "Peppy Paneer, Onion Tomato, Green Chilies, Corn, Italian Sprinkle",
                                                    "imageId": "ocafwv6i9csobnarmj5d",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987195",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571820",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571821",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571822",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571820"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095359",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095361",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571821"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661957",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095365",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571822"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095367",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095368",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095358",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095366",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095364",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095363",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095359",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095365",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095367",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095361",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661957",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095368",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095362",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {},
                                                    "showImage": true,
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.7",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ],
                                    "type": "CATEGORY_TYPE_RECOMMENDED"
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Combos",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225779",
                                                    "name": "Aaloo Tikki Burger + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "a5522bb0496cd1ed083a0a75ae7864e8",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094796",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094798",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.3",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225780",
                                                    "name": "Aaloo Tikki Burger + Fries + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "57f7eb944bb9fd029de30b045fa70b92",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094799",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094801",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.3",
                                                            "ratingCount": "13 ratings",
                                                            "ratingCountV2": "13"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225781",
                                                    "name": "Creamy Burger + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "d81206fa8f48f822bcfa31b854f1ddcb",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094802",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094804",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225782",
                                                    "name": "Creamy Burger\t+ Fries + Cold Drink [400ml]",
                                                    "category": "Combos",
                                                    "imageId": "529725b4faa78b70fc2ce2ec95d69d94",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094805",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094807",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.2",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225783",
                                                    "name": "Tandoori Burger + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "0b0338a181b8f9eb6dca46c273311bb5",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094808",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094810",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225784",
                                                    "name": "Tandoori Burger + Fries + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "a1a418f5faf3616d308898da7d10fe07",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094811",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094813",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.7",
                                                            "ratingCount": "7 ratings",
                                                            "ratingCountV2": "7"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225785",
                                                    "name": "Veg Spicy Burger + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "42952df844492d1a3f48f47222607fc9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094814",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094816",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225786",
                                                    "name": "Veg Spicy Burger + Fries + Cold Drink [400 Ml]",
                                                    "category": "Combos",
                                                    "imageId": "0625aed2f51e3e6db76eab35628dc6ce",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094817",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094819",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "115995652",
                                                    "name": "Chef Special Stuffed Garlic Breadfully Loaded+ Cold Drink (400 Ml)",
                                                    "category": "Combos",
                                                    "imageId": "14d2b090e56780dcbb71305d13206bc1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661915",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661914",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.0",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599216",
                                                    "name": "Aaloo Patty Sub + Cold Drink (400 Ml)",
                                                    "category": "Combos",
                                                    "imageId": "96908c8e2cc842ed00846f7181277bdf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661909",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661908",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599217",
                                                    "name": "Cheese Corn Pizza (small) + Cold Drink (400 Ml)",
                                                    "category": "Combos",
                                                    "imageId": "abfe644c509d13054f9349790ea49e94",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661911",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661910",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599218",
                                                    "name": "Cheese Maggie + Cold Drink (400 Ml)",
                                                    "category": "Combos",
                                                    "imageId": "d9faef274eb22ee2b4eceebf6fe352db",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661913",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661912",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.9",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599223",
                                                    "name": "Punjabi Pizza ( Small) + Cold Drink (400ml)",
                                                    "category": "Combos",
                                                    "imageId": "e039ea234695bc4dab11489ead973cf7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 20900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661917",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661916",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.2",
                                                            "ratingCount": "22 ratings",
                                                            "ratingCountV2": "22"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599226",
                                                    "name": "Veegie Delight Sub + Cold Drink (400ml)",
                                                    "category": "Combos",
                                                    "imageId": "3ef7e4b7fbba99a4d1b838015995710b",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661921",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661920",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "119599227",
                                                    "name": "Veg Exotic Sandwich + Cold Dink (400ml)",
                                                    "category": "Combos",
                                                    "imageId": "385b0eb9bf226a99752a4b5005274211",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661923",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661922",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "121572662",
                                                    "name": "Spicy Tandoori Sandwich + Cold Drink (400ml)",
                                                    "category": "Combos",
                                                    "imageId": "a8cb1344dcb9a7d8c0ad90174652b613",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19900,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661919",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661918",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Starters",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814702",
                                                    "name": "French Fries",
                                                    "category": "Starters",
                                                    "imageId": "5216ecf85f34e1fd8990a7c8fffdab66",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094826",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094828",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.0",
                                                            "ratingCount": "16 ratings",
                                                            "ratingCountV2": "16"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106445",
                                                    "name": "Spicy French Fries",
                                                    "category": "Starters",
                                                    "imageId": "a3268c499fa40f6771a65dacf7c272d9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094835",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094837",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934704",
                                                    "name": "Cheese Balls",
                                                    "category": "Starters",
                                                    "imageId": "d230588ecef03cb2bc82f0e128352d1e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094820",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094822",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.5",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934728",
                                                    "name": "Cheese Fries",
                                                    "category": "Starters",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 20000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115668580",
                                                            "groupName": "Add On Vanila Ice",
                                                            "choices": [
                                                                {
                                                                    "id": "102291573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115668581",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115668582",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777471",
                                                    "name": "Loaded  Fries",
                                                    "category": "Starters",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094829",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094831",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777473",
                                                    "name": "Peri-peri Fries.",
                                                    "category": "Starters",
                                                    "imageId": "fdd8802b236d90e501aeda161da77e82",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094832",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094834",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Momo's",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "113482128",
                                                    "name": "Veg Fried Momo",
                                                    "category": "Momo's",
                                                    "imageId": "ad8574dc00e631548548bf6e47a2a23c",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661929",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661928",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797776",
                                                    "name": "Cheese Corn Momo",
                                                    "category": "Momo's",
                                                    "imageId": "ada83b9e74adb5661e7df7963d58620a",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661925",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661924",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797777",
                                                    "name": "Cheese Loded Momo",
                                                    "category": "Momo's",
                                                    "imageId": "1debc96fafdb96c81410d35c1f7f5809",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661927",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661926",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797778",
                                                    "name": "Mushroom Momo",
                                                    "category": "Momo's",
                                                    "imageId": "2ce5977563eb5fcf561da9a5ceebc605",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661931",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661930",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797779",
                                                    "name": "Paneer Fried Momo",
                                                    "category": "Momo's",
                                                    "imageId": "a3061a04469ffce42d70a1d13e72337d",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661933",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661932",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797780",
                                                    "name": "Paneer Momo",
                                                    "category": "Momo's",
                                                    "imageId": "d42569ea31da9a4987b7a76f04d5e177",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661935",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661934",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797781",
                                                    "name": "Veg Momo",
                                                    "category": "Momo's",
                                                    "imageId": "255b2fbc02810fd8048dea596e1c2410",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661937",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661936",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Spring Roll",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797783",
                                                    "name": "Paneer Spring Roll",
                                                    "category": "Spring Roll",
                                                    "imageId": "be73fe0c6d617a4ccd23974306bd0849",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661939",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661938",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125797784",
                                                    "name": "Veg Spring Roll",
                                                    "category": "Spring Roll",
                                                    "imageId": "4bcc27f90dc1e49d4a91522ae32575fd",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661941",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661940",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "CHINESE Starters ",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495437",
                                                    "name": "Veg Crispy",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "866840dd7559df5dc05ea145a4e064d1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 23000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094868",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094870",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509837",
                                                    "name": "Lemon Paneer Gravy",
                                                    "category": "CHINESE Starters ",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094856",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094858",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509838",
                                                    "name": "Honey Chilli Potato",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "bfa8d337415d606d39f2fe5b69defc47",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094853",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094855",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.3",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509839",
                                                    "name": "Schezwan Manchurian Gravy",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "9a49f30efa63fc823328934e8ebcc10b",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 22000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094862",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094864",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509840",
                                                    "name": "Schezwan Manchurian Dry",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "612ac9681ddd7582451a5f552df5c7e9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 22000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094859",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094861",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509841",
                                                    "name": "Cheese Chilli Gravy",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "0b001a3bba5c5b8e4183469358e8b880",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094841",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094843",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509842",
                                                    "name": "Cheese Chilli Dry",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "fa6d67315e0bd5a563ae2f0349c47a29",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094838",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094840",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.0",
                                                            "ratingCount": "8 ratings",
                                                            "ratingCountV2": "8"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509843",
                                                    "name": "Veg Manchurian Gravy",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "0784262769c817c4bed9a028c5cdf491",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094874",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094876",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.3",
                                                            "ratingCount": "9 ratings",
                                                            "ratingCountV2": "9"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509844",
                                                    "name": "Veg Manchurian Dry",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "43bf8e48caf000f1058f13f21b78565b",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094871",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094873",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509845",
                                                    "name": "Chilli Mushroom Gravy",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "558004c2db9dc6463c73bd14d851c80c",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 23000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094847",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094849",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509846",
                                                    "name": "Chilli Mushroom Dry",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "6f7c00ed34842adc8ecd5cebbde4a505",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 23000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094844",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094846",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509848",
                                                    "name": "Crispy Paneer",
                                                    "category": "CHINESE Starters ",
                                                    "imageId": "4ede9e6513758321289b99f848484832",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 27000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094850",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094852",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "113237892",
                                                    "name": "Corn Salt & Pepper",
                                                    "category": "CHINESE Starters ",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 22000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "83899713",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "83899712",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Rice & Noodles",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495434",
                                                    "name": "Mushroom & Corn Fried Rice",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "0f3c419c83037538054dc1f632b1d029",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094892",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094894",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.3",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495435",
                                                    "name": "Cheese Noodles",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "d4f5fb0e3fcd092959c8bb56c97cf781",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094877",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094879",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.2",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495436",
                                                    "name": "Fried Rice",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "d559f9583f6b3a21fee2443909f3ebad",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094883",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094885",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.7",
                                                            "ratingCount": "7 ratings",
                                                            "ratingCountV2": "7"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495439",
                                                    "name": "Hakka Noodles",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "7cfdd7e392d26414b33536e851a29f75",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094889",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094891",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.9",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495440",
                                                    "name": "Singapore Noodles",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "0110e211e51028e48a9527cac773f6c9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094898",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094900",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.0",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495441",
                                                    "name": "Veg Noodles",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "307488252c58c0390e18414200bcbeb7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14800,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094904",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094906",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495442",
                                                    "name": "Chilli Garlic Noodles",
                                                    "category": "Rice & Noodles",
                                                    "imageId": "0b30d989878777ce96396327b67c55de",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094880",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094882",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "1.0",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125808416",
                                                    "name": "Punjabi Fried Rice",
                                                    "category": "Rice & Noodles",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 22000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661943",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661942",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125808417",
                                                    "name": "Sechwan Noodles",
                                                    "category": "Rice & Noodles",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661945",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661944",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Soups",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495429",
                                                    "name": "Tomato Soup",
                                                    "category": "Soups",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094909",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094908",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495431",
                                                    "name": "Veg Manchow Soup",
                                                    "category": "Soups",
                                                    "imageId": "135a7566c6a089a4cf7df85cdfddfed0",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094912",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094911",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495432",
                                                    "name": "Veg Sweet Corn Soup",
                                                    "category": "Soups",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094915",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094914",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                    "title": "Burgers And Sandwiches",
                                    "categories": [
                                        {
                                            "title": "Burgers",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814749",
                                                            "name": "Farm Fresh Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "8d96c925e3b3896d5872bbbfb46cb516",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095453",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095456",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095455",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.5",
                                                                    "ratingCount": "37 ratings",
                                                                    "ratingCountV2": "37"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814790",
                                                            "name": "Paneer Tikka Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "38a3e788bd9414d61c6a081e1880ca83",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095473",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095476",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095475",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.0",
                                                                    "ratingCount": "6 ratings",
                                                                    "ratingCountV2": "6"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814811",
                                                            "name": "King Size Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "55dabefdf7f87c3a12ca0a28f606535e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095461",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095464",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095463",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.7",
                                                                    "ratingCount": "9 ratings",
                                                                    "ratingCountV2": "9"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814815",
                                                            "name": "Cheese Cheddar Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "75c76f5c52246b118a9901382f37231d",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095433",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095436",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095435",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.6",
                                                                    "ratingCount": "5 ratings",
                                                                    "ratingCountV2": "5"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814817",
                                                            "name": "Crunchy Paneer Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "krgvd8t20uits69obs11",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095445",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095448",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095447",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.6",
                                                                    "ratingCount": "7 ratings",
                                                                    "ratingCountV2": "7"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106428",
                                                            "name": "Paneer Makhani Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "0d10020e2c8f359c5f57c619571ee5f9",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 12000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095469",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095472",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095471",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704350",
                                                            "name": "Chef's Favourite Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "f15da0f9ead6eb4be2122336fcbf72ce",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095437",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095440",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095439",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.9",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109225814",
                                                            "name": "Aalo Tikki Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "131ed917bf2497c965ac0379f4028784",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095429",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095430",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095432",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "37 ratings",
                                                                    "ratingCountV2": "37"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109225815",
                                                            "name": "Creamy Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "fea355a5b3a886ade7839db4be40d944",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 7500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095441",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095442",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095444",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {
                                                                "text": "Bestseller",
                                                                "textColor": "#ffffff",
                                                                "topBackgroundColor": "#d53d4c",
                                                                "bottomBackgroundColor": "#b02331"
                                                            },
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "isBestseller": true,
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "16 ratings",
                                                                    "ratingCountV2": "16"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109225816",
                                                            "name": "Tandoori Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "b57bd02598a83439cecbdf4d4149febc",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095477",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095478",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095480",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "14 ratings",
                                                                    "ratingCountV2": "14"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "109225817",
                                                            "name": "Veg Spicy Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "31a93d3aa08c2cdca0ce7091a88d6006",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 8000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095481",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095482",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095484",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.8",
                                                                    "ratingCount": "6 ratings",
                                                                    "ratingCountV2": "6"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125808418",
                                                            "name": "Double Tikki Burger",
                                                            "category": "Burgers And Sandwiches",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 9000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115661960",
                                                                    "groupName": "Make it a Meal",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60999854",
                                                                            "name": "French Fries+pepsi [450 Ml]",
                                                                            "price": 10000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "115661959",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "115661958",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "title": "Sandwiches",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57812715",
                                                            "name": "Veg Exotic Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "5b339d6205ba8dc0b05c05bf95d95749",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095502",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095501",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.3",
                                                                    "ratingCount": "8 ratings",
                                                                    "ratingCountV2": "8"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814977",
                                                            "name": "Bombay Club Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 24000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095487",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095486",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814978",
                                                            "name": "Spicy Tandoori Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "125cbc99ee12ae38cffd920457c7475e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095499",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095498",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "4.7",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814981",
                                                            "name": "Cheese Corn Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "c99019c2fe99fa7aa6e63a86abbd4076",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095490",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095489",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "3.1",
                                                                    "ratingCount": "18 ratings",
                                                                    "ratingCountV2": "18"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106432",
                                                            "name": "Paneer Makhani Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "e10b840bc4de6f5162bdbd944c8ac1ce",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095493",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095492",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125911172",
                                                            "name": "Mashroom Delight Sandwich",
                                                            "category": "Burgers And Sandwiches",
                                                            "imageId": "5f4680df5dac5440fbcfdef7b502e792",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19500,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115661903",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "115661902",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                    "title": "Snacks",
                                    "categories": [
                                        {
                                            "title": "Garlic Bread",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106464",
                                                            "name": "Supreme Stuffed Garlic Bread",
                                                            "category": "Snacks",
                                                            "imageId": "ce429edf30063a612dafe9eba1b3c503",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095533",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095532",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704358",
                                                            "name": "Stuffed Garlic Bread Cheese",
                                                            "category": "Snacks",
                                                            "imageId": "9585aefafa5a2945a6b785ec9997f968",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11900,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095518",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095517",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704359",
                                                            "name": "Stuffed Garlic Mushroom And Corn",
                                                            "category": "Snacks",
                                                            "imageId": "b8a6bba2deec8651de2c3505581e54d9",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095524",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095523",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704365",
                                                            "name": "Slice Garlic Bread Cheese [4 Slice]",
                                                            "category": "Snacks",
                                                            "imageId": "651f78ec204d4fd93bb8ac0fabb23153",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 14800,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095505",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095504",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704372",
                                                            "name": "Slice Mushroom And Corn [4 Slice]",
                                                            "category": "Snacks",
                                                            "imageId": "dfa031b94e9b4ff8bf9fc426595d7fcd",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095508",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095507",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704475",
                                                            "name": "Supreme Garlic Bread [4 Slice]",
                                                            "category": "Snacks",
                                                            "imageId": "f864187f8d4a6cd105eadd82f9b39808",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095530",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095529",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704490",
                                                            "name": "Stuffed Chef Spiceal Fully Loded Garlic Bread",
                                                            "category": "Snacks",
                                                            "imageId": "cf0ac1cc32290a22f18199875d271409",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095527",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095526",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "2.8",
                                                                    "ratingCount": "4 ratings",
                                                                    "ratingCountV2": "4"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704495",
                                                            "name": "Chef Spiceal Fully Loded Garlic Bread [6 Slice].",
                                                            "category": "Snacks",
                                                            "imageId": "42c85176e954de6e1c62b7ed6ed20180",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 19000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095511",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095510",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "title": "Calzone Cave",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704361",
                                                            "name": "Peri Peri Calzone Cave",
                                                            "category": "Snacks",
                                                            "imageId": "c2674b7f640b4e8c34b9e847f4573be2",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095539",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095538",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "102704364",
                                                            "name": "Spicy Tandoori Calzone Cave",
                                                            "category": "Snacks",
                                                            "imageId": "3ffd274d0a9fe700cbd6beacc9fd3647",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115661905",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "115661904",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104495454",
                                                            "name": "Cheese Corn Calzone Cave",
                                                            "category": "Snacks",
                                                            "imageId": "238ba3cd452159d33b623a01ff047fda",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 15000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76095536",
                                                                    "groupName": "Extra Dip",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998441",
                                                                            "name": "Mayonies Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998442",
                                                                            "name": "Tandoori Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998443",
                                                                            "name": "Chilly Garlic Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998432",
                                                                            "name": "Sezwan Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998433",
                                                                            "name": "Green Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998434",
                                                                            "name": "Red Chilly Dip",
                                                                            "price": 1500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998435",
                                                                            "name": "Chipolata Dip",
                                                                            "price": 2000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                },
                                                                {
                                                                    "groupId": "76095535",
                                                                    "groupName": "Add On [ketchup]",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998438",
                                                                            "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                            "price": 500,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        },
                                                                        {
                                                                            "id": "60998439",
                                                                            "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                            "price": 1000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Sub",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814529",
                                                    "name": "Paneer Tikka Sub",
                                                    "category": "Sub",
                                                    "imageId": "13777b96e4f72ff2bad275c71a466eea",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094953",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094952",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.3",
                                                            "ratingCount": "19 ratings",
                                                            "ratingCountV2": "19"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106358",
                                                    "name": "Falafel Sub",
                                                    "category": "Sub",
                                                    "imageId": "u1ufmirwo13udeame9re",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094947",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094946",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.8",
                                                            "ratingCount": "8 ratings",
                                                            "ratingCountV2": "8"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106359",
                                                    "name": "Hara Bhara Kabab Sub",
                                                    "category": "Sub",
                                                    "imageId": "vfevo8dvkp3jelpxmnlx",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094950",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094949",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.0",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934764",
                                                    "name": "Aloo Patty Sub",
                                                    "category": "Sub",
                                                    "imageId": "7780d7c21717906a1eeef94ac03f02fa",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 17000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094941",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094940",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777478",
                                                    "name": "Tandoori Paneer Sub.",
                                                    "category": "Sub",
                                                    "imageId": "630a7d7b8ccb91be572eb5d437a7268a",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094956",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094955",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777479",
                                                    "name": "Veggie Delight Sub.",
                                                    "category": "Sub",
                                                    "imageId": "b46dbab4e49cb7583201eedfa44715d6",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094959",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094958",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Wraps",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814513",
                                                    "name": "Kohlapuri Paneer Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "aa9e714ba569ff65c746fbf50b6bc32a",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661811",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661810",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106366",
                                                    "name": "Cheese Mushroom Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "1db297216ec26dadc6aa7dd475a1c3d7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095013",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095012",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "5.0",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106367",
                                                    "name": "Hara Bhara Kabab Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "ac2cf86e28331221f896abda28ae8013",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095019",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095018",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106370",
                                                    "name": "Spicy Aloo Tikki Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "68775a6849306a9c3570d90dbfacceb9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095031",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095030",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934923",
                                                    "name": "Paneer Cheese Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "fefe3e3ce10b792edffe111414b673f8",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 16000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661813",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661812",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.7",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934924",
                                                    "name": "Veggie Delight Wrap",
                                                    "category": "Wraps",
                                                    "imageId": "a56ffb17cb2b7ff7a418d3ad6a4fa679",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661815",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661814",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Maggi",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814492",
                                                    "name": "Tandoori Maggi",
                                                    "category": "Maggi",
                                                    "imageId": "b5c5a2d80c0ee9efb347544658d47e60",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094989",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094988",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.0",
                                                            "ratingCount": "15 ratings",
                                                            "ratingCountV2": "15"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106372",
                                                    "name": "Cheese Maggi",
                                                    "category": "Maggi",
                                                    "imageId": "b3879cdfa377206ba373dbc31568edba",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094965",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094964",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.7",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106377",
                                                    "name": "Masala Mix Veg Maggi",
                                                    "category": "Maggi",
                                                    "imageId": "afcc80c9a6f71892e4dce5ba2f7db849",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094974",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094973",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.9",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106382",
                                                    "name": "Spicy Maggi",
                                                    "category": "Maggi",
                                                    "imageId": "34f0a2d36f5af10506c729cc70605a92",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094983",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094982",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.1",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934930",
                                                    "name": "Cheese Corn Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "d60af22054ac45619f1f126db617d038",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661817",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661816",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934932",
                                                    "name": "Double Cheese Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "f283baaaf68ce0548be4f51cef1ff354",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661819",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661818",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934935",
                                                    "name": "Makhni Veggie Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "03fdb480ab3e91614703b9b6773c5fd5",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661821",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661820",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934944",
                                                    "name": "Masala Pyaza Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "0cea1cf2f53443b3bf46324266b59cc1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661823",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661822",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934970",
                                                    "name": "Peri-peri Veggie Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "efa06ba2242a3551b4dc5079feeae2eb",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661829",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661828",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79935040",
                                                    "name": "Tandoori Veggie Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "6c84ff635fb67c2e54c7d4e6097db3af",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661831",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661830",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125925046",
                                                    "name": "Spicy Paneer Maggie",
                                                    "category": "Maggi",
                                                    "imageId": "9e8c64db59aaae4202ea399d7be899b3",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115668583",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115668584",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Salads",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814543",
                                                    "name": "Farm Fresh Salad",
                                                    "category": "Salads",
                                                    "description": "Iceberg, Tamato, Cucumber, Onion, Black Olives, Pineapple, Jelapino 7 Sweet Corn",
                                                    "imageId": "1acddae5d1f37b507e15e61dfc9a4cdd",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094998",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094997",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "1.9",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57815003",
                                                    "name": "English Salad",
                                                    "category": "Salads",
                                                    "description": "Ice Berg, Tamato, Cucumber, Onion, Bellpepper, Olives, Pineapple, Jelaphino & Sweet Corn With Paneer",
                                                    "imageId": "85064ddb8fec533b5c0a381fb699abf0",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094995",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094994",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "1.1",
                                                            "ratingCount": "3 ratings",
                                                            "ratingCountV2": "3"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106362",
                                                    "name": "Mexican Salad",
                                                    "category": "Salads",
                                                    "description": "Ice Berg, Tamato, Cucumber, Onion, Mix Fruit Wit Bellpepper",
                                                    "imageId": "9df974723f35f20c4cfa2bcba133aef3",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095004",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095003",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934916",
                                                    "name": "Maxican Patty Salad",
                                                    "category": "Salads",
                                                    "description": "(ice burg, tomato, cucumber, onion, pineapple, jalapeno, sweet corn and serve with Fried patato patty )",
                                                    "imageId": "007bc34fbd44c9c19448dcfcfd8fd0f1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661833",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661832",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "79934917",
                                                    "name": "Paneer Diet Salad",
                                                    "category": "Salads",
                                                    "description": "(ice burg, tomato, cucumber, onion, mixed fruit, broccli, paneer with bell pepper and without sause)",
                                                    "imageId": "a994eda6526f32a16369a0279ce89cb1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "115661835",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661834",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.4",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Lava Burgers",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777487",
                                                    "name": "Cheese Corn Lava Burger.",
                                                    "category": "Lava Burgers",
                                                    "imageId": "0b8ec976e850f1127701303d2e0c7af0",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094923",
                                                            "groupName": "Make it a Meal",
                                                            "choices": [
                                                                {
                                                                    "id": "60999854",
                                                                    "name": "French Fries+pepsi [450 Ml]",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094926",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094925",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.5",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777488",
                                                    "name": "Peri- Peri Lava Burger.",
                                                    "category": "Lava Burgers",
                                                    "imageId": "1385462555ba23b7b3ec28811bdb7af7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094927",
                                                            "groupName": "Make it a Meal",
                                                            "choices": [
                                                                {
                                                                    "id": "60999854",
                                                                    "name": "French Fries+pepsi [450 Ml]",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094930",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094929",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777490",
                                                    "name": "Veggie Makhni Lava Burger.",
                                                    "category": "Lava Burgers",
                                                    "imageId": "877e55d5159da7c5cb35de4403f52f71",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76094935",
                                                            "groupName": "Make it a Meal",
                                                            "choices": [
                                                                {
                                                                    "id": "60999854",
                                                                    "name": "French Fries+pepsi [450 Ml]",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094938",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76094937",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Pasta",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901444",
                                                    "name": "Cheesy Paneer Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushroom, Golden Corn, Broccoli, Mixed Capsicum With Cheesy Creamy Red Sauce.",
                                                    "imageId": "lwizmtizfrgz4nonjskf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095043",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095041",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095042",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901448",
                                                    "name": "Cheese Mushroom Pasta",
                                                    "category": "Pasta",
                                                    "description": "Broccoli, Black Olives, Mushrooms, Mozzarella Cheese With Cheesy Creamy White Sauce.",
                                                    "imageId": "8ccad97dec185982953fdfd53da55f06",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095039",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095036",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095038",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "5.0",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901449",
                                                    "name": "Makhani Gravy Pasta",
                                                    "category": "Pasta",
                                                    "description": "Golden Corn, Green Zucchini, Mushroom, Mix Capsicum, Broccoli Red Sauce.",
                                                    "imageId": "hht1kgq5vjnwvrosmkcu",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095055",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095052",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095054",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901452",
                                                    "name": "Red Sause Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushroom, Zucchini, Broccoli, Mixed Capsicum With Italian Napoli Red Sauce.",
                                                    "imageId": "6b4fd15230669d12ed5243bd695abf6e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095063",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095060",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095062",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "2.5",
                                                            "ratingCount": "14 ratings",
                                                            "ratingCountV2": "14"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57901454",
                                                    "name": "Tandoori Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushroom, Mix Capsicum With Cheesy Blend And Tandoori Red Sauce.",
                                                    "imageId": "48ea2071b0026eef75cb253174870f23",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095067",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095064",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095066",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777492",
                                                    "name": "Creamy Alferado Pasta",
                                                    "category": "Pasta",
                                                    "description": "Broccoli, Mushrooms, Capsicum, Golden Corns With Chef'S Special White Sauce.",
                                                    "imageId": "bebhwh4vdput2n5xhhox",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 26000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095047",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095045",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095046",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "1.5",
                                                            "ratingCount": "16 ratings",
                                                            "ratingCountV2": "16"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777493",
                                                    "name": "Mix N Match Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mushrooms, Tomato, Golden Corn, Zucchini, Mixed Capsicums, Mozzarella Cheese With Cheesy Creamy Red Sauce.",
                                                    "imageId": "98865607107605e9bfba8e91c4b730be",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 25000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095059",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095056",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095058",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777494",
                                                    "name": "White Pasta",
                                                    "category": "Pasta",
                                                    "description": "Mix Capsicum, Onion With Cheesy Creamy White Sauce.",
                                                    "imageId": "ddeaf0511029ccd50760be0a8be2af90",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 24000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76095071",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095068",
                                                            "groupName": "Extra Bread",
                                                            "choices": [
                                                                {
                                                                    "id": "60999858",
                                                                    "name": "Extra Bread",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095070",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "5.0",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Pizza",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814293",
                                                    "name": "Tandoori Paneer Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onion, Capcicum And Paneer In Tandoori Sauce.",
                                                    "imageId": "7573eec339d60fd4b215092d9a15dd3d",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987194",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571817",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571818",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571819",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987194",
                                                                        "variationId": "77571817"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095347",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095346",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095349",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987194",
                                                                        "variationId": "77571818"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095353",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095354",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095352",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987194",
                                                                        "variationId": "77571819"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095351",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095355",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095357",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095350",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095356",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095347",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095356",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095353",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095351",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095346",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095352",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095355",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095349",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095354",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095357",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095350",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "5.0",
                                                            "ratingCount": "17 ratings",
                                                            "ratingCountV2": "17"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814315",
                                                    "name": "Chilly Paneer Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onions, Green Capsicum, Mushrooms Marinated Paneer And Sliced Black Olives.",
                                                    "imageId": "y4qvzirgfp5jr0dbs0eo",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987176",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571762",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571763",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571764",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571762"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095132",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095133",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095135",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571763"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095139",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095140",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095138",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987176",
                                                                        "variationId": "77571764"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095141",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095143",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095136",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095137",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095142",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095133",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095142",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095139",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095137",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095132",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095138",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095141",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095135",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095140",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095143",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095136",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.8",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814419",
                                                    "name": "Veg Fiesta Pizza",
                                                    "category": "Pizza",
                                                    "description": "Sweet Corn, Onion, Capsicum And Broccoli.",
                                                    "imageId": "79ca19af04ebdeaa48f1a48715e21b37",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987197",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 210,
                                                                        "default": 1,
                                                                        "id": "77571826",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 310,
                                                                        "id": "77571827",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 410,
                                                                        "id": "77571828",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571826"
                                                                    }
                                                                ],
                                                                "price": 21000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095381",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095382",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095384",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571827"
                                                                    }
                                                                ],
                                                                "price": 31000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095387",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095389",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095388",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987197",
                                                                        "variationId": "77571828"
                                                                    }
                                                                ],
                                                                "price": 41000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095391",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095392",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095385",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095386",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095390",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095381",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095390",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095387",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095386",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095382",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095388",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095391",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095384",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095389",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095392",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095385",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 21000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.2",
                                                            "ratingCount": "27 ratings",
                                                            "ratingCountV2": "27"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814429",
                                                    "name": "Spicy Veg Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onion And Capsicum In Chilli Garlic Dip.",
                                                    "imageId": "65eb883aa100bbf62b9d3d1213735e32",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987192",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 210,
                                                                        "default": 1,
                                                                        "id": "77571811",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 310,
                                                                        "id": "77571812",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 410,
                                                                        "id": "77571813",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987192",
                                                                        "variationId": "77571811"
                                                                    }
                                                                ],
                                                                "price": 21000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095322",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095323",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095325",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987192",
                                                                        "variationId": "77571812"
                                                                    }
                                                                ],
                                                                "price": 31000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095328",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095330",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095329",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987192",
                                                                        "variationId": "77571813"
                                                                    }
                                                                ],
                                                                "price": 41000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095332",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095333",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095326",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095327",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095331",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095322",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095331",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095328",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095327",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095323",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095329",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095332",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095325",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095330",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095333",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095326",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 21000,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.0",
                                                            "ratingCount": "23 ratings",
                                                            "ratingCountV2": "23"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814437",
                                                    "name": "Capsicum Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Capcicum And Basil With Spices.",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987171",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571747",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571748",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571749",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987171",
                                                                        "variationId": "77571747"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095072",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095073",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095075",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987171",
                                                                        "variationId": "77571748"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095079",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095080",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095078",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987171",
                                                                        "variationId": "77571749"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095081",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095083",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095076",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095077",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095082",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095073",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095082",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095079",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095077",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095072",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095078",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095081",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095075",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095080",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095083",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095076",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.1",
                                                            "ratingCount": "9 ratings",
                                                            "ratingCountV2": "9"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814444",
                                                    "name": "Onion Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Slice Onion And Basil With Spice.",
                                                    "imageId": "fa5b61e33859bf752976bb2fed8e3a82",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987186",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571793",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571794",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571795",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987186",
                                                                        "variationId": "77571793"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095252",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095253",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095255",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987186",
                                                                        "variationId": "77571794"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095258",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095260",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095259",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987186",
                                                                        "variationId": "77571795"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095262",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095263",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095256",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095257",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095261",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095252",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095261",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095258",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095257",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095253",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095259",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095262",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095255",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095260",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095263",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095256",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.7",
                                                            "ratingCount": "23 ratings",
                                                            "ratingCountV2": "23"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814460",
                                                    "name": "Cheese Corn Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Corn And Basil With Spices.",
                                                    "imageId": "627d39f2d09159ecd8a6c660207032bf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987172",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571750",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571751",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571752",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571750"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095084",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095085",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095087",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571751"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095090",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095092",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095091",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987172",
                                                                        "variationId": "77571752"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095089",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095094",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095095",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095088",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095093",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095084",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095093",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095090",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095089",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095085",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095091",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095094",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095087",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095092",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095095",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095088",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.2",
                                                            "ratingCount": "134 ratings",
                                                            "ratingCountV2": "134"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106389",
                                                    "name": "Cheese Margherita Pizza",
                                                    "category": "Pizza",
                                                    "description": "Classic Italian Pizza With Hot Cheese Toppings.",
                                                    "imageId": "0491c52474ff2f1ffbbc799c652f05b1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987173",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "77571753",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 278,
                                                                        "id": "77571754",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 378,
                                                                        "id": "77571755",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987173",
                                                                        "variationId": "77571753"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095096",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095097",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095099",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987173",
                                                                        "variationId": "77571754"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095102",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095104",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095103",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987173",
                                                                        "variationId": "77571755"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095101",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095106",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095107",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095100",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095105",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095096",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095105",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095102",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095101",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095097",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095103",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095106",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095099",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095104",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095107",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095100",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.3",
                                                            "ratingCount": "25 ratings",
                                                            "ratingCountV2": "25"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106390",
                                                    "name": "Cheese Mushroom Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Slice Mushroom And Basil With Spices.",
                                                    "imageId": "40a78c473a49e9c5303383da368eae9a",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987174",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 180,
                                                                        "default": 1,
                                                                        "id": "77571756",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 280,
                                                                        "id": "77571757",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571758",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987174",
                                                                        "variationId": "77571756"
                                                                    }
                                                                ],
                                                                "price": 18000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095109",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095108",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095111",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987174",
                                                                        "variationId": "77571757"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095115",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095116",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095114",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987174",
                                                                        "variationId": "77571758"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095113",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095117",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095119",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095112",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095118",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095109",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095118",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095115",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095113",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095108",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095114",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095117",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095111",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095116",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095119",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095112",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 18000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106392",
                                                    "name": "Cheese Tomato Pizza",
                                                    "category": "Pizza",
                                                    "description": "Hot Cheese, Tomato Slices And Basil With Spices.",
                                                    "imageId": "e6399f9f9c4bc0f53f0616e54fc796cc",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987175",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571759",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571760",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571761",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987175",
                                                                        "variationId": "77571759"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095120",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095121",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095123",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987175",
                                                                        "variationId": "77571760"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095126",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095128",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095127",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987175",
                                                                        "variationId": "77571761"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095130",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095131",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095124",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095125",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095129",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095120",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095129",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095126",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095125",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095121",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095127",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095130",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095123",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095128",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095131",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095124",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106399",
                                                    "name": "Masala Paneer Makhani Pizza",
                                                    "category": "Pizza",
                                                    "description": "Marinated Paneer, Onion, Capsicum Red Paprika,Tomatoes, Coriander Cheese With Hot Cheese Topping.",
                                                    "imageId": "1f9dd9907f24daf44583e7b34673bef1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987183",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571784",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571785",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571786",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571784"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095216",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095217",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095219",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571785"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095222",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095224",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095223",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987183",
                                                                        "variationId": "77571786"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095226",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095227",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095220",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095221",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095225",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095216",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095225",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095222",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095221",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095217",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095223",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095226",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095219",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095224",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095227",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095220",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.6",
                                                            "ratingCount": "6 ratings",
                                                            "ratingCountV2": "6"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106401",
                                                    "name": "Mexican Choice Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onion, Capsicum, Sweet Corn, Jalapeno With Toppings Of Red Paprika.",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987184",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 240,
                                                                        "default": 1,
                                                                        "id": "77571787",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 340,
                                                                        "id": "77571788",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 440,
                                                                        "id": "77571789",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987184",
                                                                        "variationId": "77571787"
                                                                    }
                                                                ],
                                                                "price": 24000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095228",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095229",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095231",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987184",
                                                                        "variationId": "77571788"
                                                                    }
                                                                ],
                                                                "price": 34000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095235",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095236",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095234",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987184",
                                                                        "variationId": "77571789"
                                                                    }
                                                                ],
                                                                "price": 44000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095237",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095239",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095232",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095233",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095238",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095229",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095238",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095235",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095233",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095228",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095234",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095237",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095231",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095236",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095239",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095232",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 24000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "5.0",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106404",
                                                    "name": "Ultimate Paneer Pizza",
                                                    "category": "Pizza",
                                                    "description": "Peppy Paneer, Onion Tomato, Green Chilies, Corn, Italian Sprinkle",
                                                    "imageId": "ocafwv6i9csobnarmj5d",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987195",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 280,
                                                                        "default": 1,
                                                                        "id": "77571820",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 380,
                                                                        "id": "77571821",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 480,
                                                                        "id": "77571822",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571820"
                                                                    }
                                                                ],
                                                                "price": 28000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095358",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095359",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095361",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571821"
                                                                    }
                                                                ],
                                                                "price": 38000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095364",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661957",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095365",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987195",
                                                                        "variationId": "77571822"
                                                                    }
                                                                ],
                                                                "price": 48000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095367",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095368",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095362",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095363",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095366",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095358",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095366",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095364",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095363",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095359",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095365",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095367",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095361",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661957",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095368",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095362",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 28000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.7",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777642",
                                                    "name": "Double Cheese Pizza.",
                                                    "category": "Pizza",
                                                    "description": "Classic Italian pizza with double mozrella cheese topping",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987179",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 200,
                                                                        "default": 1,
                                                                        "id": "77571771",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 300,
                                                                        "id": "77571772",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 400,
                                                                        "id": "77571773",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987179",
                                                                        "variationId": "77571771"
                                                                    }
                                                                ],
                                                                "price": 20000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095168",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095169",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095171",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987179",
                                                                        "variationId": "77571772"
                                                                    }
                                                                ],
                                                                "price": 30000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095174",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095176",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095175",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987179",
                                                                        "variationId": "77571773"
                                                                    }
                                                                ],
                                                                "price": 40000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095178",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095179",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095172",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095173",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095177",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095168",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095177",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095174",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095173",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095169",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095175",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095178",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095171",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095176",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095179",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095172",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 20000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777643",
                                                    "name": "Farm House.",
                                                    "category": "Pizza",
                                                    "description": "Onion, capsicum, tomato, sweet corn and mushroom",
                                                    "imageId": "4f090cb34a0767cc5ee780c34589c925",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987180",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 210,
                                                                        "default": 1,
                                                                        "id": "77571774",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 310,
                                                                        "id": "77571775",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 410,
                                                                        "id": "77571776",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987180",
                                                                        "variationId": "77571774"
                                                                    }
                                                                ],
                                                                "price": 21000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095180",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095181",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095183",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987180",
                                                                        "variationId": "77571775"
                                                                    }
                                                                ],
                                                                "price": 31000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095186",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095188",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095187",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987180",
                                                                        "variationId": "77571776"
                                                                    }
                                                                ],
                                                                "price": 41000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095190",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095191",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095184",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095185",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095189",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095180",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095189",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095186",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095185",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095181",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095187",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095190",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095183",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095188",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095191",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095184",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 21000,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.5",
                                                            "ratingCount": "9 ratings",
                                                            "ratingCountV2": "9"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777644",
                                                    "name": "Hawaiian Pizza.",
                                                    "category": "Pizza",
                                                    "description": "A classic combination of pineapple, mix capsicum, red paprika and corn",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987181",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 230,
                                                                        "default": 1,
                                                                        "id": "77571777",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 330,
                                                                        "id": "77571778",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 430,
                                                                        "id": "77571779",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987181",
                                                                        "variationId": "77571777"
                                                                    }
                                                                ],
                                                                "price": 23000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095192",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095193",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095195",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987181",
                                                                        "variationId": "77571778"
                                                                    }
                                                                ],
                                                                "price": 33000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095198",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095200",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095199",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987181",
                                                                        "variationId": "77571779"
                                                                    }
                                                                ],
                                                                "price": 43000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095202",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095203",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095196",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095197",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095201",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095192",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095201",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095198",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095197",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095193",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095199",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095202",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095195",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095200",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095203",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095196",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 23000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777646",
                                                    "name": "Onion & Paneer.",
                                                    "category": "Pizza",
                                                    "description": "Hot cheese, Sliced onion and paneer",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987185",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "77571790",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 278,
                                                                        "id": "77571791",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 378,
                                                                        "id": "77571792",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987185",
                                                                        "variationId": "77571790"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095240",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095241",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095243",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987185",
                                                                        "variationId": "77571791"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095246",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095248",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095247",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987185",
                                                                        "variationId": "77571792"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095250",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095251",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095244",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095245",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095249",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095240",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095249",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095246",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095245",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095241",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095247",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095250",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095243",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095248",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095251",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095244",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777684",
                                                    "name": "Veg Exotica.",
                                                    "category": "Pizza",
                                                    "description": "The garden fresh combination of onion, mushroom, sweet corn & green capsicum topped with red paprika",
                                                    "imageId": "0c5edf03e6fbc06cf30cb7d76fde3775",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987196",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 250,
                                                                        "default": 1,
                                                                        "id": "77571823",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 350,
                                                                        "id": "77571824",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 450,
                                                                        "id": "77571825",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987196",
                                                                        "variationId": "77571823"
                                                                    }
                                                                ],
                                                                "price": 25000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095369",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095370",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095372",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987196",
                                                                        "variationId": "77571824"
                                                                    }
                                                                ],
                                                                "price": 35000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095375",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095377",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095376",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987196",
                                                                        "variationId": "77571825"
                                                                    }
                                                                ],
                                                                "price": 45000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095379",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095380",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095373",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095374",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095378",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095369",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095378",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095375",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095374",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095370",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095376",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095379",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095372",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095377",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095380",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095373",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 25000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777685",
                                                    "name": "Veg Loaded.",
                                                    "category": "Pizza",
                                                    "description": "A seven topping loaded pizza with onion, mushroom, corn, jalepenos, sliced black olive with red capsicum & zucchini",
                                                    "imageId": "fa325bb9147492fb5bfe44bd6d203499",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987198",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 250,
                                                                        "default": 1,
                                                                        "id": "77571829",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 350,
                                                                        "id": "77571830",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 450,
                                                                        "id": "77571831",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987198",
                                                                        "variationId": "77571829"
                                                                    }
                                                                ],
                                                                "price": 25000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095393",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095394",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095396",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987198",
                                                                        "variationId": "77571830"
                                                                    }
                                                                ],
                                                                "price": 35000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095399",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095401",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095400",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987198",
                                                                        "variationId": "77571831"
                                                                    }
                                                                ],
                                                                "price": 45000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095403",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095404",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095397",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095398",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095402",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095393",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095402",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095399",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095398",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095394",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095400",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095403",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095396",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095401",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095404",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095397",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 25000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777686",
                                                    "name": "Veggie Lover.",
                                                    "category": "Pizza",
                                                    "description": "Mushroom, capsicum, onion, tomato, baby corn, olive and pineapple",
                                                    "imageId": "1c4a708238b6792765deab6aa7e111ab",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987200",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 250,
                                                                        "default": 1,
                                                                        "id": "77571835",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 350,
                                                                        "id": "77571836",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 450,
                                                                        "id": "77571837",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987200",
                                                                        "variationId": "77571835"
                                                                    }
                                                                ],
                                                                "price": 25000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095417",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095418",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095420",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987200",
                                                                        "variationId": "77571836"
                                                                    }
                                                                ],
                                                                "price": 35000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095423",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095425",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095424",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987200",
                                                                        "variationId": "77571837"
                                                                    }
                                                                ],
                                                                "price": 45000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095427",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095428",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095421",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095422",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095426",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095417",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095426",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095423",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095422",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095418",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095424",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095427",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095420",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095425",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095428",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095421",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 25000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "106567954",
                                                    "name": "Veg Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onion, capsicum, tomato with cheese blend and mozzarella cheese",
                                                    "imageId": "3055e6ca9b0945c92db4d31b5f706eea",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987199",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "77571832",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "77571833",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "77571834",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987199",
                                                                        "variationId": "77571832"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095405",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095407",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095409",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987199",
                                                                        "variationId": "77571833"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095411",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095413",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095412",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987199",
                                                                        "variationId": "77571834"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095406",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095415",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095416",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095410",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095414",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095405",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095414",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095411",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095406",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095407",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095412",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095415",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095409",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095413",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095416",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095410",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.1",
                                                            "ratingCount": "67 ratings",
                                                            "ratingCountV2": "67"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "109225812",
                                                    "name": "Punjabi Pizza",
                                                    "category": "Pizza",
                                                    "description": "Onion, capcicum, tomato, paneer with cheese blend and mozrella cheese",
                                                    "imageId": "3cc56b8250110edff311cd94fc4ccbaf",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987188",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 185,
                                                                        "default": 1,
                                                                        "id": "77571799",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 285,
                                                                        "id": "77571800",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 385,
                                                                        "id": "77571801",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987188",
                                                                        "variationId": "77571799"
                                                                    }
                                                                ],
                                                                "price": 18500,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "76095276",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661956",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "76095279",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998439"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987188",
                                                                        "variationId": "77571800"
                                                                    }
                                                                ],
                                                                "price": 28500,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "76095281",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "76095282",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661955",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987188",
                                                                        "variationId": "77571801"
                                                                    }
                                                                ],
                                                                "price": 38500,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "76095277",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661954",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "76095284",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "76095280",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "76095283",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "76095276",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095283",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095281",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095277",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661956",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661955",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661954",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095279",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095282",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095284",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "76095280",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 18500,
                                                    "ribbon": {
                                                        "text": "Bestseller",
                                                        "textColor": "#ffffff",
                                                        "topBackgroundColor": "#d53d4c",
                                                        "bottomBackgroundColor": "#b02331"
                                                    },
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "isBestseller": true,
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "4.1",
                                                            "ratingCount": "68 ratings",
                                                            "ratingCountV2": "68"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911161",
                                                    "name": "Cappsicum & Paneer Pizza.",
                                                    "category": "Pizza",
                                                    "description": "Cappsicum, Paneer, mozzarella & processed cheese",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087254",
                                                                "name": "Size",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "102396772",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium",
                                                                        "price": 278,
                                                                        "id": "102396773",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large",
                                                                        "price": 378,
                                                                        "id": "102396774",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087254",
                                                                        "variationId": "102396772"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661836",
                                                                        "addonId": "60999873"
                                                                    },
                                                                    {
                                                                        "groupId": "115661837",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661838",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998435"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087254",
                                                                        "variationId": "102396773"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661845",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661842",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661844",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087254",
                                                                        "variationId": "102396774"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661843",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661841",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661839",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661840",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661846",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661836",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661846",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661845",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661840",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661837",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661844",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661843",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661838",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661842",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661841",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661839",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911162",
                                                    "name": "Corn & Cappsicum Pizza",
                                                    "category": "Pizza",
                                                    "description": "( hot cheese, sliced &corn with spices)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087255",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "102396775",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 278,
                                                                        "id": "102396776",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 378,
                                                                        "id": "102396777",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087255",
                                                                        "variationId": "102396775"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661850",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661853",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661857",
                                                                        "addonId": "60999873"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087255",
                                                                        "variationId": "102396776"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661849",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661855",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661852",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087255",
                                                                        "variationId": "102396777"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661847",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661848",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661851",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661854",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661856",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661857",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661856",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661855",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661854",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661853",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661852",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661851",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661850",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661849",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661848",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661847",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911163",
                                                    "name": "Indian Veg Pizza",
                                                    "category": "Pizza",
                                                    "description": "( onion, cappsicum, tomato, garlic, green chili, jelphino )",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087256",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 210,
                                                                        "default": 1,
                                                                        "id": "102396778",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 330,
                                                                        "id": "102396779",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 430,
                                                                        "id": "102396780",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087256",
                                                                        "variationId": "102396778"
                                                                    }
                                                                ],
                                                                "price": 21000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661861",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661864",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661868",
                                                                        "addonId": "60999873"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087256",
                                                                        "variationId": "102396779"
                                                                    }
                                                                ],
                                                                "price": 33000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661860",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661866",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661863",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087256",
                                                                        "variationId": "102396780"
                                                                    }
                                                                ],
                                                                "price": 43000,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661858",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661859",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661862",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661865",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661867",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661868",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661867",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661866",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661865",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661864",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661863",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661862",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661861",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661860",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661859",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661858",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 21000,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911164",
                                                    "name": "Onion & Corn Pizza",
                                                    "category": "Pizza",
                                                    "description": "( hot cheese, sliced onion and corn)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087257",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "102396781",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 278,
                                                                        "id": "102396782",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 378,
                                                                        "id": "102396783",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087257",
                                                                        "variationId": "102396781"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661872",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661875",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661879",
                                                                        "addonId": "60999873"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087257",
                                                                        "variationId": "102396782"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661871",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661877",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661874",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087257",
                                                                        "variationId": "102396783"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661869",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661870",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661873",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661876",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661878",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661879",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661878",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661877",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661876",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661875",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661874",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661873",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661872",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661871",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661870",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661869",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911165",
                                                    "name": "Onion & Pineapple Pizza",
                                                    "category": "Pizza",
                                                    "description": "( hot cheese , sliced onion & pineapple cheese)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087258",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 178,
                                                                        "default": 1,
                                                                        "id": "102396784",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 278,
                                                                        "id": "102396785",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 378,
                                                                        "id": "102396786",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087258",
                                                                        "variationId": "102396784"
                                                                    }
                                                                ],
                                                                "price": 17800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661883",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661886",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661890",
                                                                        "addonId": "60999873"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087258",
                                                                        "variationId": "102396785"
                                                                    }
                                                                ],
                                                                "price": 27800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661882",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661888",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661885",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087258",
                                                                        "variationId": "102396786"
                                                                    }
                                                                ],
                                                                "price": 37800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661880",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661881",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661884",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661887",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661889",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661890",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661889",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661888",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661887",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661886",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661885",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661884",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661883",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661882",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661881",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661880",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 17800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911166",
                                                    "name": "Veg Corn Pizza",
                                                    "category": "Pizza",
                                                    "description": "( onion & cappsicum sweet corn serve with mozarella cheese)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "33087259",
                                                                "name": "Portion",
                                                                "variations": [
                                                                    {
                                                                        "name": "Regular [8 Inches]",
                                                                        "price": 148,
                                                                        "default": 1,
                                                                        "id": "102396787",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Medium [10 Inches]",
                                                                        "price": 248,
                                                                        "id": "102396788",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Large [12 Inches]",
                                                                        "price": 348,
                                                                        "id": "102396789",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087259",
                                                                        "variationId": "102396787"
                                                                    }
                                                                ],
                                                                "price": 14800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661894",
                                                                        "addonId": "60999874"
                                                                    },
                                                                    {
                                                                        "groupId": "115661897",
                                                                        "addonId": "60999864"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999865"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999866"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999867"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999868"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999869"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999870"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999871"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999872"
                                                                    },
                                                                    {
                                                                        "groupId": "115661901",
                                                                        "addonId": "60999873"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087259",
                                                                        "variationId": "102396788"
                                                                    }
                                                                ],
                                                                "price": 24800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661893",
                                                                        "addonId": "60999885"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999876"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999877"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999878"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999879"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999880"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999881"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999882"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999883"
                                                                    },
                                                                    {
                                                                        "groupId": "115661899",
                                                                        "addonId": "60999884"
                                                                    },
                                                                    {
                                                                        "groupId": "115661896",
                                                                        "addonId": "60999875"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "33087259",
                                                                        "variationId": "102396789"
                                                                    }
                                                                ],
                                                                "price": 34800,
                                                                "addonCombinations": [
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998438"
                                                                    },
                                                                    {
                                                                        "groupId": "115661891",
                                                                        "addonId": "60998439"
                                                                    },
                                                                    {
                                                                        "groupId": "115661892",
                                                                        "addonId": "60999896"
                                                                    },
                                                                    {
                                                                        "groupId": "115661895",
                                                                        "addonId": "60999886"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998441"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998442"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998443"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998432"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998433"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998434"
                                                                    },
                                                                    {
                                                                        "groupId": "115661898",
                                                                        "addonId": "60998435"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999887"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999888"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999889"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999890"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999891"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999892"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999893"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999894"
                                                                    },
                                                                    {
                                                                        "groupId": "115661900",
                                                                        "addonId": "60999895"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "addons": [
                                                        {
                                                            "groupId": "115661901",
                                                            "groupName": "Extra Toppings [8 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999869",
                                                                    "name": "Zucchini",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999865",
                                                                    "name": "Paneer",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999866",
                                                                    "name": "Broccoli",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999867",
                                                                    "name": "Capsicum",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999868",
                                                                    "name": "Red Paprika",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999872",
                                                                    "name": "Olive",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999873",
                                                                    "name": "Jalapeno",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999870",
                                                                    "name": "Onion",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999871",
                                                                    "name": "Corn",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661900",
                                                            "groupName": "Extra Toppings [12 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999887",
                                                                    "name": "Paneer",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999888",
                                                                    "name": "Broccoli",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999889",
                                                                    "name": "Capsicum",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999894",
                                                                    "name": "Olive",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999895",
                                                                    "name": "Jalapeno",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999890",
                                                                    "name": "Red Paprika",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999891",
                                                                    "name": "Zucchini",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999892",
                                                                    "name": "Onion",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999893",
                                                                    "name": "Corn",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661899",
                                                            "groupName": "Extra Toppings [10 Inches]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999876",
                                                                    "name": "Paneer",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999877",
                                                                    "name": "Broccoli",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999878",
                                                                    "name": "Capsicum",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999879",
                                                                    "name": "Red Paprika",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999883",
                                                                    "name": "Olive",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999884",
                                                                    "name": "Jalapeno",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999880",
                                                                    "name": "Zucchini",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999881",
                                                                    "name": "Onion",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60999882",
                                                                    "name": "Corn",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 5,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661898",
                                                            "groupName": "Extra Dip",
                                                            "choices": [
                                                                {
                                                                    "id": "60998441",
                                                                    "name": "Mayonies Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998442",
                                                                    "name": "Tandoori Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998443",
                                                                    "name": "Chilly Garlic Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998432",
                                                                    "name": "Sezwan Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998433",
                                                                    "name": "Green Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998434",
                                                                    "name": "Red Chilly Dip",
                                                                    "price": 1500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998435",
                                                                    "name": "Chipolata Dip",
                                                                    "price": 2000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661897",
                                                            "groupName": "Extra Cheese brust [Reg]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999864",
                                                                    "name": "Cheese Brust",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661896",
                                                            "groupName": "Extra Cheese brust [Med]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999875",
                                                                    "name": "Cheese Brust",
                                                                    "price": 10000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661895",
                                                            "groupName": "Extra Cheese brust [Large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999886",
                                                                    "name": "Cheese Brust",
                                                                    "price": 13000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661894",
                                                            "groupName": "Extra Cheese [regular]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999874",
                                                                    "name": "Extra Cheese",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661893",
                                                            "groupName": "Extra [medium]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999885",
                                                                    "name": "Extra Cheese",
                                                                    "price": 5000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661892",
                                                            "groupName": "Extras [large]",
                                                            "choices": [
                                                                {
                                                                    "id": "60999896",
                                                                    "name": "Extra Cheese",
                                                                    "price": 7000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        },
                                                        {
                                                            "groupId": "115661891",
                                                            "groupName": "Add On [ketchup]",
                                                            "choices": [
                                                                {
                                                                    "id": "60998438",
                                                                    "name": "1 Tomato Ketchup + 1 Oregano + 1 Chilli Flacks",
                                                                    "price": 500,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                },
                                                                {
                                                                    "id": "60998439",
                                                                    "name": "2 Tomato Ketchup + 2 Oregano + 2 Chilli Flacks",
                                                                    "price": 1000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 14800,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Chai ",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495485",
                                                    "name": "Lemon Green Tea",
                                                    "category": "Chai ",
                                                    "imageId": "d264b33fd32f3ff7ca21a8e0a920023e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 8000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495486",
                                                    "name": "Kesar Chai",
                                                    "category": "Chai ",
                                                    "imageId": "c5a7038a543dfd7a4449cdaff53174bc",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 9500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495487",
                                                    "name": "Masala Chai",
                                                    "category": "Chai ",
                                                    "imageId": "b64f7527e2aa331c7a1b2c8296e155ac",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 8000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495488",
                                                    "name": "Honey Green Tea",
                                                    "category": "Chai ",
                                                    "imageId": "5d050ac78db1690e710a958daf8d7089",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 8000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495489",
                                                    "name": "Adrak Chai",
                                                    "category": "Chai ",
                                                    "imageId": "3f7c3335d22a6a35cbc310df10e32457",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 8000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495491",
                                                    "name": "Elachi Chai",
                                                    "category": "Chai ",
                                                    "imageId": "8e7c21deca9421ae7637684e870189ca",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 8000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Hot Coffee ",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814676",
                                                    "name": "Hot Coffee",
                                                    "category": "Hot Coffee ",
                                                    "imageId": "f3878586926949ad0a5f856f896fe2dc",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 10500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495460",
                                                    "name": "Black Coffee",
                                                    "category": "Hot Coffee ",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 10500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495462",
                                                    "name": "Irish Cream Coffee",
                                                    "category": "Hot Coffee ",
                                                    "imageId": "6fddef48d74fee4f8d90ebbe97c7cea7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495463",
                                                    "name": "Hazelnut Coffee",
                                                    "category": "Hot Coffee ",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495466",
                                                    "name": "Chocolate Coffee",
                                                    "category": "Hot Coffee ",
                                                    "imageId": "6414973d0ce23655dc4feb3b106ce7f8",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495467",
                                                    "name": "Caramel Coffee",
                                                    "category": "Hot Coffee ",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 11500,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Mojitos",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106466",
                                                    "name": "Mint Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "2ff92ddd6a14ad6ea99149579bc7ab73",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777357",
                                                    "name": "Blue Blush Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "aff39ff5bad9cdcaed337c4e6ab55c73",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777358",
                                                    "name": "Bubble Gum Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "e65591fc5006b7cafd4f0a3b1bad9b55",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777360",
                                                    "name": "Fresh Lemon Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "b25410adf8448b30f5e060005caf93a5",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777362",
                                                    "name": "Green Apple Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "8854196ed46f7fc873d93d15ddfc5008",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777363",
                                                    "name": "Kala Khata Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "d2bab1b767aad08cb7198a143af88cd5",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777365",
                                                    "name": "Malt Beer Flavour Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "9662796923ff4cfb1324f6aa3a0f55e0",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777366",
                                                    "name": "Masala Mango Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "adc7969c6c22a9b43c5d111102749223",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777367",
                                                    "name": "Peach Ice Tea",
                                                    "category": "Mojitos",
                                                    "imageId": "5944da60ef1e6ca7627f3b413d7b144e",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 13000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777368",
                                                    "name": "Pineapple Chilli Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "17eb82538583821f2c5ca5ab45e95556",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777369",
                                                    "name": "Virgin Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "d1e2f41dc26107c04bb596b868bdd6dd",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777370",
                                                    "name": "Watermelon Mojito",
                                                    "category": "Mojitos",
                                                    "imageId": "a9992a3410707cb7c6bd8c2863d0d42a",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 12000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                    "title": "Desserts And Beverages",
                                    "categories": [
                                        {
                                            "title": "Slush's",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814617",
                                                            "name": "Mango Slush",
                                                            "category": "Desserts And Beverages",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814621",
                                                            "name": "Blackcurrent Slush",
                                                            "category": "Desserts And Beverages",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814623",
                                                            "name": "Orange Slush",
                                                            "category": "Desserts And Beverages",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "100777688",
                                                            "name": "Kala Khata Ice Slush",
                                                            "category": "Desserts And Beverages",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 11000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "title": "Cold Coffee",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "57814604",
                                                            "name": "Cold Coffee",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "23c32257784c39309b939bd4cd31f6a4",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 13000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115661907",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.2",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104495464",
                                                            "name": "Cold Coffee Frapee",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "60bfc6a0455cb75ca512d0693aae9631",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 16000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76093558",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {
                                                                    "rating": "1.2",
                                                                    "ratingCount": "3 ratings",
                                                                    "ratingCountV2": "3"
                                                                }
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104495748",
                                                            "name": "Cold Coffee Icecream",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "c7a56ba00a55d12e719bb6cbb289635b",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76093556",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104495749",
                                                            "name": "Hazelnut Coffee Frappe",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "2c17d3ccc6be87077e7871bc99f6b208",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76093559",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "104495752",
                                                            "name": "Caramel Coffee Frappe",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "4d6badf78872c39cbe2074f2efa36c08",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 17000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "76093551",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125911173",
                                                            "name": "Coffee Frappe Irish Cream",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "d95a51a476e134185406b5ccf1d5ece2",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115661906",
                                                                    "groupName": "Choose your Ice Cream",
                                                                    "choices": [
                                                                        {
                                                                            "id": "60998573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "title": "Chocolate Shakes",
                                            "itemCards": [
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106489",
                                                            "name": "Brownie Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "2758f434da6f91b5733b2278b8b82da8",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106495",
                                                            "name": "Ferrero Rocher Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "2ec75c31a235e414a7f8ab3d679fa823",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106497",
                                                            "name": "Oreo Brownie Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "861d58ea8f64c39b842116ff395450d3",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "75106500",
                                                            "name": "Oreo Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "f890dc0d5fe88856ec115d1ecbeb5287",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "100777692",
                                                            "name": "Kit Kat Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "f44ad1aa9f7347402ba323882c93b323",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "100777693",
                                                            "name": "Nutty Belgian Dark Chocolate Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "d963b6a516f1855ddce3e64946e2ca71",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125911174",
                                                            "name": "Chocollate Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "4c651e8162556f93eb741c33ace3c578",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115668585",
                                                                    "groupName": "Add On Vanila Ice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "102291573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125911175",
                                                            "name": "Cookies & Cream Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "cfa5048b6b63ef678c55e980bef1d81f",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115668586",
                                                                    "groupName": "Add On Vanila Ice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "102291573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                },
                                                {
                                                    "card": {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        "info": {
                                                            "id": "125911176",
                                                            "name": "Mocha Browine Shake",
                                                            "category": "Desserts And Beverages",
                                                            "imageId": "4c1491a321223d58ab84c3762768455e",
                                                            "inStock": 1,
                                                            "isVeg": 1,
                                                            "price": 18000,
                                                            "variants": {},
                                                            "variantsV2": {},
                                                            "addons": [
                                                                {
                                                                    "groupId": "115668587",
                                                                    "groupName": "Add On Vanila Ice",
                                                                    "choices": [
                                                                        {
                                                                            "id": "102291573",
                                                                            "name": "Vanilla Ice Cream",
                                                                            "price": 3000,
                                                                            "inStock": 1,
                                                                            "isVeg": 1,
                                                                            "isEnabled": 1
                                                                        }
                                                                    ],
                                                                    "maxAddons": 1,
                                                                    "maxFreeAddons": -1
                                                                }
                                                            ],
                                                            "itemAttribute": {
                                                                "vegClassifier": "VEG"
                                                            },
                                                            "ribbon": {},
                                                            "type": "ITEM",
                                                            "itemBadge": {},
                                                            "badgesV2": {},
                                                            "ratings": {
                                                                "aggregatedRating": {}
                                                            }
                                                        },
                                                        "analytics": {},
                                                        "hideRestaurantDetails": true
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Thik Shakes (standard)",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "57814553",
                                                    "name": "Butterscotch",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "4078e845a69abb43b9d539fd69019a12",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093439",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495446",
                                                    "name": "Vanilla",
                                                    "category": "Thik Shakes (standard)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093455",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495449",
                                                    "name": "Tutti Frutti",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "a1970822aa8f948fb847d22a20fb430b",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093454",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495494",
                                                    "name": "Strawderry",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "21a6c48e52ada35a77a9eeb4df9ac67d",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093449",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495495",
                                                    "name": "Fresh Pineapple",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "eeefe39e1a3b4158813236302f882d07",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093440",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495709",
                                                    "name": "Paan",
                                                    "category": "Thik Shakes (standard)",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093442",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495719",
                                                    "name": "Raj Bhog",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "824ad6e041a73604a7f8dbbcc018b1d3",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093443",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495729",
                                                    "name": "Kaju Draklsh",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "a7854c01380b900c8877cce800fdf754",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093447",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495741",
                                                    "name": "Kesar Pista",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "b7180695c64ec6c3ae7ebda639b25277",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093441",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495744",
                                                    "name": "Alphonso Mango",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "67064419eb4bfe6e27af8156252ab9d1",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093434",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104495745",
                                                    "name": "American Nuts",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "922c2aa0b3eb257345247e1e6ac6a6d4",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093435",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "104509849",
                                                    "name": "Black Cvrrant",
                                                    "category": "Thik Shakes (standard)",
                                                    "imageId": "65bf03e09c35470ce639892158da41c7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 15000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "addons": [
                                                        {
                                                            "groupId": "76093438",
                                                            "groupName": "Choose your Ice Cream",
                                                            "choices": [
                                                                {
                                                                    "id": "60998573",
                                                                    "name": "Vanilla Ice Cream",
                                                                    "price": 3000,
                                                                    "inStock": 1,
                                                                    "isVeg": 1,
                                                                    "isEnabled": 1
                                                                }
                                                            ],
                                                            "maxAddons": 1,
                                                            "maxFreeAddons": -1
                                                        }
                                                    ],
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Waffle",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777408",
                                                    "name": "Hot Chocolate Waffle",
                                                    "category": "Waffle",
                                                    "imageId": "6d3f9332a46a6804aab9767309706727",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777409",
                                                    "name": "Nutella Waffle",
                                                    "category": "Waffle",
                                                    "imageId": "76298f9308870ed36fccc830f660feee",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 19000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911167",
                                                    "name": "Almond Browine Waffle",
                                                    "category": "Waffle",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 21000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911168",
                                                    "name": "Honey Butter Waffle",
                                                    "category": "Waffle",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125925047",
                                                    "name": "Almond Nutella Browine",
                                                    "category": "Waffle",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 20000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Hot Waffle Desserts",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777402",
                                                    "name": "Chocolate Lovers Waffle",
                                                    "category": "Hot Waffle Desserts",
                                                    "imageId": "02f98deb324937a9138ede7489fb04a7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 24000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777403",
                                                    "name": "Classic Waffle",
                                                    "category": "Hot Waffle Desserts",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 23000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777404",
                                                    "name": "Cookies & Cream Waffle",
                                                    "category": "Hot Waffle Desserts",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 24000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777406",
                                                    "name": "Nutty Belgain Waffle",
                                                    "category": "Hot Waffle Desserts",
                                                    "imageId": "f4708fc74a1e95b94fa555b1f8f7bcc4",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 24000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777407",
                                                    "name": "Strawberry Hot Waffle",
                                                    "category": "Hot Waffle Desserts",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 22000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Waffle Cake",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911169",
                                                    "name": "Almond Browine Waffle Cake ( Single Layer )",
                                                    "category": "Waffle Cake",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 30000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911170",
                                                    "name": "Nuttella Chocolate Waffle Cake ( Single Layer)",
                                                    "category": "Waffle Cake",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 30000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Brownie Sundaes",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "75106471",
                                                    "name": "Brownie Sundae",
                                                    "category": "Brownie Sundaes",
                                                    "imageId": "c828af9fba7499e4157b400898479ff3",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.8",
                                                            "ratingCount": "5 ratings",
                                                            "ratingCountV2": "5"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777412",
                                                    "name": "Brownie Choco Sundae",
                                                    "category": "Brownie Sundaes",
                                                    "imageId": "4f69c7da49f19c0a023bd22b6c245111",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 18000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "125911171",
                                                    "name": "Browine With Hot Chocolate",
                                                    "category": "Brownie Sundaes",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "price": 14000,
                                                    "variants": {},
                                                    "variantsV2": {},
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Classic Icecream",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777423",
                                                    "name": "American Nuts Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "3b5ef45110b69b42e041cbfa83b37da9",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987055",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 96.25,
                                                                        "default": 1,
                                                                        "id": "77571484",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 113.75,
                                                                        "id": "77571485",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 131.25,
                                                                        "id": "77571486",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987055",
                                                                        "variationId": "77571484"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987055",
                                                                        "variationId": "77571485"
                                                                    }
                                                                ],
                                                                "price": 11375
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987055",
                                                                        "variationId": "77571486"
                                                                    }
                                                                ],
                                                                "price": 13125
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 9625,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {
                                                            "rating": "3.5",
                                                            "ratingCount": "4 ratings",
                                                            "ratingCountV2": "4"
                                                        }
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777425",
                                                    "name": "Butter Scotch Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "9579b896d41a8cb969e78d5899591813",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987056",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571487",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571488",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571489",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987056",
                                                                        "variationId": "77571487"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987056",
                                                                        "variationId": "77571488"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987056",
                                                                        "variationId": "77571489"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777427",
                                                    "name": "Kaju Draksh Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "996833a1a47c3520d028f8b570ddf2cd",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987058",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571493",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571494",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571495",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987058",
                                                                        "variationId": "77571493"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987058",
                                                                        "variationId": "77571494"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987058",
                                                                        "variationId": "77571495"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777430",
                                                    "name": "Kesar Pista Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "3e87112caedcfa66c367dd28484d5507",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987060",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571499",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571500",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571501",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987060",
                                                                        "variationId": "77571499"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987060",
                                                                        "variationId": "77571500"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987060",
                                                                        "variationId": "77571501"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777431",
                                                    "name": "Paan Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "fb4c35d25afb82cc7792a173a84ee4d7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987061",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571502",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571503",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571504",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987061",
                                                                        "variationId": "77571502"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987061",
                                                                        "variationId": "77571503"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987061",
                                                                        "variationId": "77571504"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777433",
                                                    "name": "Raj Bhog Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "1e6a9efa3104efd90a6ed78517ad54fd",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987062",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 96.25,
                                                                        "default": 1,
                                                                        "id": "77571505",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 113.75,
                                                                        "id": "77571506",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 131.25,
                                                                        "id": "77571507",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987062",
                                                                        "variationId": "77571505"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987062",
                                                                        "variationId": "77571506"
                                                                    }
                                                                ],
                                                                "price": 11375
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987062",
                                                                        "variationId": "77571507"
                                                                    }
                                                                ],
                                                                "price": 13125
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 9625,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777438",
                                                    "name": "Vanilla Icecream",
                                                    "category": "Classic Icecream",
                                                    "imageId": "c48efcbea121fabd2db30dbffe4752c7",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987066",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571517",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571518",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571519",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987066",
                                                                        "variationId": "77571517"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987066",
                                                                        "variationId": "77571518"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987066",
                                                                        "variationId": "77571519"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                    "title": "Fruits Ice Cream",
                                    "itemCards": [
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777414",
                                                    "name": "Alphonso Mango Icecream",
                                                    "category": "Fruits Ice Cream",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987047",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571460",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571461",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571462",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987047",
                                                                        "variationId": "77571460"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987047",
                                                                        "variationId": "77571461"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987047",
                                                                        "variationId": "77571462"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777415",
                                                    "name": "Black Currant Icecream",
                                                    "category": "Fruits Ice Cream",
                                                    "imageId": "7f16b31c74060f3f68facd6be6d1f383",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987048",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 96.25,
                                                                        "default": 1,
                                                                        "id": "77571463",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 113.75,
                                                                        "id": "77571464",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 131.25,
                                                                        "id": "77571465",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987048",
                                                                        "variationId": "77571463"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987048",
                                                                        "variationId": "77571464"
                                                                    }
                                                                ],
                                                                "price": 11375
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987048",
                                                                        "variationId": "77571465"
                                                                    }
                                                                ],
                                                                "price": 13125
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 9625,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777416",
                                                    "name": "Fresh Pineapple Icecream",
                                                    "category": "Fruits Ice Cream",
                                                    "imageId": "d907d47763526f49585ddf464f172b98",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987049",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571466",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571467",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571468",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987049",
                                                                        "variationId": "77571466"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987049",
                                                                        "variationId": "77571467"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987049",
                                                                        "variationId": "77571468"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777418",
                                                    "name": "Strawberry Icecream",
                                                    "category": "Fruits Ice Cream",
                                                    "imageId": "c52f52e3e14c29fb41b8f3e7ef0d8811",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987051",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 78.75,
                                                                        "default": 1,
                                                                        "id": "77571472",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 96.25,
                                                                        "id": "77571473",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 122.5,
                                                                        "id": "77571474",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987051",
                                                                        "variationId": "77571472"
                                                                    }
                                                                ],
                                                                "price": 7875
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987051",
                                                                        "variationId": "77571473"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987051",
                                                                        "variationId": "77571474"
                                                                    }
                                                                ],
                                                                "price": 12250
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 7875,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        },
                                        {
                                            "card": {
                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                "info": {
                                                    "id": "100777419",
                                                    "name": "Tutty Fruitty Icecream",
                                                    "category": "Fruits Ice Cream",
                                                    "imageId": "36723d9dc21e83e2ffdf2acd17d2e990",
                                                    "inStock": 1,
                                                    "isVeg": 1,
                                                    "variants": {},
                                                    "variantsV2": {
                                                        "variantGroups": [
                                                            {
                                                                "groupId": "23987052",
                                                                "name": "Customisation",
                                                                "variations": [
                                                                    {
                                                                        "name": "Small Scoop (62gm)",
                                                                        "price": 96.25,
                                                                        "default": 1,
                                                                        "id": "77571475",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Regular Scoop (95gm)",
                                                                        "price": 113.75,
                                                                        "id": "77571476",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    },
                                                                    {
                                                                        "name": "Double Scoop (120gm)",
                                                                        "price": 131.25,
                                                                        "id": "77571477",
                                                                        "inStock": 1,
                                                                        "isVeg": 1,
                                                                        "isEnabled": 1
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "pricingModels": [
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987052",
                                                                        "variationId": "77571475"
                                                                    }
                                                                ],
                                                                "price": 9625
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987052",
                                                                        "variationId": "77571476"
                                                                    }
                                                                ],
                                                                "price": 11375
                                                            },
                                                            {
                                                                "variations": [
                                                                    {
                                                                        "groupId": "23987052",
                                                                        "variationId": "77571477"
                                                                    }
                                                                ],
                                                                "price": 13125
                                                            }
                                                        ]
                                                    },
                                                    "itemAttribute": {
                                                        "vegClassifier": "VEG"
                                                    },
                                                    "defaultPrice": 9625,
                                                    "ribbon": {},
                                                    "type": "ITEM",
                                                    "itemBadge": {},
                                                    "badgesV2": {},
                                                    "ratings": {
                                                        "aggregatedRating": {}
                                                    }
                                                },
                                                "analytics": {},
                                                "hideRestaurantDetails": true
                                            }
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                    "type": "FSSAI",
                                    "imageId": "fssai_final_edss9i",
                                    "text": [
                                        "License No. 22220091001886"
                                    ]
                                }
                            }
                        },
                        {
                            "card": {
                                "card": {
                                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                    "name": "Sip & Bite",
                                    "area": "Saraswati Nagar",
                                    "completeAddress": "180 G Block, Sri Ganganagar"
                                }
                            }
                        }
                    ]
                }
            }
        }
    }
]